import React from 'react'
import Style from './CheckCredit.module.css'
const CheckCredit = ({sendRequest,loading}) => {
  return (
    <div className={Style.ComponentHolder}>
        <p>برای اعتبارسنجی جهت دریافت کمک برست روی دکمه زیر بزنید!</p>
        <button className={Style.buttonHolder} onClick={sendRequest} disabled={loading}>
          {loading?"لطفا صبرکنید":"اعتبار سنجی"}
          </button>
    </div>
  )
}

export default CheckCredit